import { AxiosPromise } from 'axios';
import { SubAccount } from '@dev/ee-api/ee-api-models';
import { request } from './request';

export const loadSubaccounts = (limit: number, offset: number): AxiosPromise<SubAccount[]> => {
    const { SubAccounts } = request();
    return SubAccounts.subAccountsGet(limit, offset);
};
